export const getFallbackCountries = () => {
  return [
    {
      key: 'US',
      value: 'US',
      label: 'United States',
      iso_code: 'US',
      searchLabel: 'United States (US)',
    },
    {
      key: 'GB',
      value: 'GB',
      label: 'United Kingdom',
      iso_code: 'GB',
      searchLabel: 'United Kingdom (GB)',
    },
    {
      key: 'CA',
      value: 'CA',
      label: 'Canada',
      iso_code: 'CA',
      searchLabel: 'Canada (CA)',
    },
    {
      key: 'AU',
      value: 'AU',
      label: 'Australia',
      iso_code: 'AU',
      searchLabel: 'Australia (AU)',
    },
    {
      key: 'DE',
      value: 'DE',
      label: 'Germany',
      iso_code: 'DE',
      searchLabel: 'Germany (DE)',
    },
    {
      key: 'FR',
      value: 'FR',
      label: 'France',
      iso_code: 'FR',
      searchLabel: 'France (FR)',
    },
    {
      key: 'ES',
      value: 'ES',
      label: 'Spain',
      iso_code: 'ES',
      searchLabel: 'Spain (ES)',
    },
    {
      key: 'IT',
      value: 'IT',
      label: 'Italy',
      iso_code: 'IT',
      searchLabel: 'Italy (IT)',
    },
    {
      key: 'RS',
      value: 'RS',
      label: 'Serbia',
      iso_code: 'RS',
      searchLabel: 'Serbia (RS)',
    },
    {
      key: 'MX',
      value: 'MX',
      label: 'Mexico',
      iso_code: 'MX',
      searchLabel: 'Mexico (MX)',
    },
  ]
}
